import type { Location, LocationBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Location, LocationBase>({
  tableName: "locations",
  viewName: "locations_enriched",
  searchColumns: ["name", "code"],
  computedColumns: ["parentName"],
});

export class LocationService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static createMany = base.createMany;
  static update = base.update;
  static delete = base.delete;
}
